import React, { useState, useEffect } from 'react';
import { updatePopup } from '../../services/popupService';
import { SuccessCircle, WarningIcon } from '../../assets/icons';
import Spinner from '../common/Spinner';
import useModalClose from '../../hooks/useModalClose';

const STEPS = {
  FORM: 0,
  CONFIRM: 1,
  COMPLETE: 2
};

 const EditPopupModal = ({ isOpen, onClose, user, onSuccess }) => {
  const [currentStep, setCurrentStep] = useState(STEPS.FORM);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
  const [previewImage, setPreviewImage] = useState(null);
  const [previewVideo, setPreviewVideo] = useState(null);
  const [formData, setFormData] = useState({
    name: '',
 
  });
  const [updatedUser, setUpdatedUser] = useState(null);
  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      if (file.size > 5 * 1024 * 1024) {
        setError('Resim boyutu 5MB\'dan büyük olamaz.');
        return;
      }
      setFormData(prev => ({
        ...prev,
        foto: file
      }));
      setPreviewImage(URL.createObjectURL(file));
    }
  };
  useEffect(() => {
    if (user) {

      setFormData({
        baslik: user.baslik,
        icerik: user.icerik,
        baslangicTarihi: user.baslangicTarihi,
        bitisTarihi: user.bitisTarihi,
        foto: user.foto,
        video: user.video,

      });
    }
  }, [user]);

  const resetState = () => {
    setCurrentStep(STEPS.FORM);
    setIsLoading(false);
    setError(null);
    setUpdatedUser(null);
  };

  useEffect(() => {
    if (!isOpen) {
      resetState();
    }
  }, [isOpen]);

  const handleClose = () => {
    resetState();
    onClose();
  };

  const handleVideoChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      if (file.size > 10 * 1024 * 1024) {
        setError('Resim boyutu 10MB\'dan büyük olamaz.');
        return;
      }
      setFormData(prev => ({
        ...prev,
        video: file
      }));
      setPreviewVideo(URL.createObjectURL(file));
    }
  };
  const handleInputChange = (e) => {
    const { name, value } = e.target;  
   
      setFormData(prev => ({
        ...prev,
        [name]: value
      }));
    
  };

  const validateForm = () => {
    if (!formData.baslik || !formData.icerik || !formData.baslangicTarihi || !formData.bitisTarihi) {
      setError('Lütfen tüm alanları doldurunuz.');
      return false;
    }
    
    return true;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setError(null);
    
    if (validateForm()) {
      setCurrentStep(STEPS.CONFIRM);
    }
  };

  const handleBack = () => {
    setCurrentStep(STEPS.FORM);
  };

  const handleConfirm = async () => {
    setIsLoading(true);
    setError(null);
    setCurrentStep(STEPS.COMPLETE);

    try {
      await updatePopup(user.id, {
        baslik: formData.baslik,
        icerik: formData.icerik,
        baslangicTarihi: formData.baslangicTarihi,
        bitisTarihi: formData.bitisTarihi,
        foto: formData.foto instanceof File ? formData.foto : null,
        video: formData.video instanceof File ? formData.video : null,
      });
      
      const updatedUserData = {
        ...user,
        ...formData
      };
      setUpdatedUser(updatedUserData);
      onSuccess(updatedUserData);
    } catch (error) {
      setError('Kayıt güncellenirken bir hata oluştu.');
      console.error('Update user error:', error);
    } finally {
      setIsLoading(false);
    }
  };
// yardımcı: her türlü değeri date-input uyumlu string'e çevirir
function formatDateForInput(date) {
  if (!date) return "";
  if (typeof date === "string") {
    const d = new Date(date);
    if (isNaN(d)) return ""; // geçersizse boş
    return d.toISOString().substring(0, 10); // "YYYY-MM-DD"
  }
  if (date instanceof Date) {
    return date.toISOString().substring(0, 10);
  }
  return "";
}

  const renderStepIndicator = () => (
    <div className="stepper">
      <div className={`step ${currentStep >= STEPS.FORM ? 'active' : ''}`}>
        <div className="step-circle">
          {currentStep >= STEPS.FORM && <div className='step-active-circle' />}
        </div>
        <span className="step-title">Popup Bilgileri</span>
      </div>
      <div className={`step ${currentStep >= STEPS.CONFIRM ? 'active' : ''}`}>
        <div className="step-circle">
          {currentStep >= STEPS.CONFIRM && <div className='step-active-circle' />}
        </div>
        <span className="step-title">Bilgi Onayı</span>
      </div>
      <div className={`step ${currentStep >= STEPS.COMPLETE ? 'active' : ''}`}>
        <div className="step-circle">
          {currentStep >= STEPS.COMPLETE && <div className='step-active-circle' />}
        </div>
        <span className="step-title">Tamamlandı</span>
      </div>
    </div>
  );

  const renderForm = () => (
    <form onSubmit={handleSubmit} className="create-user-form">
    <div className="form-group">
      <label htmlFor="baslik">Başlık</label>
      <input
        type="text"
        id="baslik"
        name="baslik"
        value={formData.baslik}
        onChange={handleInputChange}
        placeholder="Ad"
      />
    </div>
      <div className="form-group">
        <label htmlFor="icerik">İçerik</label>
        <input
          type="text"
          id="icerik"
          name="icerik"
          value={formData.icerik}
          onChange={handleInputChange}
          placeholder="icerik"
        />
      </div>
      <div className="form-group">
        <label htmlFor="baslik">Başlangıç Tarihi</label>
        <input
          type="date"
          id="baslangicTarihi"
          name="baslangicTarihi"
          value={formatDateForInput(formData.baslangicTarihi)}
          onChange={handleInputChange}
          placeholder="baslangicTarihi"
        />
      </div>
      <div className="form-group">
        <label htmlFor="baslik">Bitiş Tarihi</label>
        <input
          type="date"
          id="bitisTarihi"
          name="bitisTarihi"
          value={formatDateForInput(formData.bitisTarihi)}
          onChange={handleInputChange}
          placeholder="Bitiş Tarihi"
        />
      </div>
      <div className="form-group">
        <label htmlFor="foto">Fotoğraf Yükle</label>
     
              {previewImage ? (
                  <img src={previewImage} alt="foto" style={{ maxWidth: "200px", height: "auto" }} />
                ) : formData.foto && typeof formData.foto === 'string' ? (
                  <img src={formData.foto} alt="foto" style={{ maxWidth: "200px", height: "auto" }} />
                ) : null}
        <input
          type="file"
          id="foto"
          name="foto"
          accept="image/*"
          onChange={handleImageChange}
        />
      </div>

      <div className="form-group">
        <label htmlFor="video">Video Yükle (max 10 mb)</label>
        {formData.video ? (
                    <a
                      href={formData.video}
                      target="_blank"
                      rel="noopener noreferrer"
                      aria-label="Video bağlantısı"
                    >
                      Video
                    </a>
                  ) : (
                    "" // veya <span aria-hidden="true">-</span> gibi görünmesini istersen
                  )}
        <input
          type="file"
          id="video"
          name="video"
          accept="video/*"
          onChange={handleVideoChange}
        />
      </div>
      {error && <div className="error-message">{error}</div>}
      <div className="form-actions">
        <button type="submit" className="submit-button">
            Düzenlemeyi Kaydet
        </button>
      </div>
    </form>
  );

  const renderConfirmation = () => (
    <div className="confirmation-step">
      <WarningIcon />
      <h3>Bilgilerini güncellemek üzeresiniz. Onaylıyor musunuz?</h3>
      <div className="table-container">
        <table className="users-table">
          <thead>
            <tr>
              <th>Başlık</th>             
              <th>İçerik</th>             
              <th>Başlangıç Tarihi</th>             
              <th>Bitiş Tarihi</th>             
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>{`${formData.baslik}`}</td>
              <td>{`${formData.icerik}`}</td>
              <td>{`${formData.baslangicTarihi}`}</td>
              <td>{`${formData.bitisTarihi}`}</td>
              
            </tr>
          </tbody>
        </table>
      </div>
      <div className="form-actions">
        <button type="button" onClick={handleBack} className="back-button">
          İptal Et
        </button>
        <button type="button" onClick={handleConfirm} className="confirm-button">
          Sonraki Adım
        </button>
      </div>
    </div>
  );

  const renderComplete = () => (
    <div className="complete-step">
      {isLoading ? (
        <div className="loading-state">
          <Spinner size="large" />
          <h3>Süreciniz tamamlanıyor...</h3>
          <button type="button" onClick={handleClose} className="cancel-button">
            Süreci İptal Et
          </button>
        </div>
      ) : updatedUser ? (
        <div className="success-state">
          <SuccessCircle />
          <h3>Süreciniz tamamlandı. Güncellendi.</h3>
          <div className="table-container">
            <table className="users-table">
            <thead>
            <tr>
              <th>Başlık</th>             
              <th>İçerik</th>             
              <th>Başlangıç Tarihi</th>             
              <th>Bitiş Tarihi</th>             
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>{`${updatedUser.baslik}`}</td>
              <td>{`${updatedUser.icerik}`}</td>
              <td>{`${updatedUser.baslangicTarihi}`}</td>
              <td>{`${updatedUser.bitisTarihi}`}</td>
              
            </tr>
              </tbody>
            </table>
          </div>
          <button type="button" onClick={handleClose} className="close-button">
            Kapat
          </button>
        </div>
      ) : (
        <div className="error-state">
          <div className="error-icon">✕</div>
          <h3>Hata Oluştu</h3>
          <p>{error}</p>
          <button type="button" onClick={handleBack} className="retry-button">
            Tekrar Dene
          </button>
        </div>
      )}
    </div>
  );

  // Add modal closing behaviors
  useModalClose(isOpen, onClose);

  if (!isOpen) return null;

  return (
    <div className="modal-overlay">
      <div className="modal-content">
        <div className="modal-header">
          <h3>Bilgileri Düzenle</h3>
        </div>
        {renderStepIndicator()}
        <div className="modal-body">
          {currentStep === STEPS.FORM && renderForm()}
          {currentStep === STEPS.CONFIRM && renderConfirmation()}
          {currentStep === STEPS.COMPLETE && renderComplete()}
        </div>
      </div>
    </div>
  );
};

export default EditPopupModal; 